import { genomeOptions } from "../../constants";
import { dataFileManager } from "../../dataFileManager";

const g = Object.keys(genomeOptions);

const initialChromosomes = Object.keys(genomeOptions).reduce((data, k) => {
  data[k] = `${dataFileManager[k].chromosomeFormat}1`;
  return data;
}, {});

const initialState = {
    current: initialChromosomes,
    // start: initializeRecord(g, 0),
    // end: initializeRecord(g, 1)
};

export const changeChromosomeSelection = (newChromosome) => {
    return {
        type: "chromosome/chromosomeSelectionChanged",
        payload: newChromosome
    };
}

// export const changeChromosomeStart = (newStart) => {
//     return {
//         type: "chromosome/chromosomeStartChanged",
//         payload: newStart
//     }
// }

// export const changeChromosomeEnd = (newEnd) => {
//     return {
//         type: "chromosome/chromosomeEndChanged",
//         payload: newEnd
//     }
// }

export const chromosomeReducer = (state = initialState, action) => {
    switch(action.type) {
        case "chromosome/chromosomeSelectionChanged":
            return {
                ...state,
                current: {
                    ...state["current"],
                    [action.payload.key]: action.payload.value
                }
            };
        // case "chromosome/chromosomeStartChanged":
        //     const { genome: g, start } = action.payload;
        //     return {
        //         ...state,
        //         start: {
        //             ...state["start"],
        //             [g]: start
        //         } 
        //     }
        // case "chromosome/chromosomeEndChanged":
        //     const { genome, end } = action.payload;
        //     return {
        //         ...state,
        //         end: {
        //             ...state["end"],
        //             [genome]: end
        //         } 
        //     }
        default:
            return state;
    };
}
